// extracted by mini-css-extract-plugin
export var codeButtonsItem = "code_buttons-module--codeButtonsItem--CGD1B";
export var codeButtonsList = "code_buttons-module--codeButtonsList--9AKdh";
export var githubButton = "code_buttons-module--githubButton--bjJDe";